import {Component, Inject, OnInit} from '@angular/core';
import {ListView} from "@domain/common/list-view";
import {Statut} from "@domain/workflow/statut";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {Page} from "@domain/common/http/list-result";
import {RelanceDetail} from "@domain/relance/relance-detail";
import {StatutRelanceListItemComponent} from "./statut-list-item/statut-relance-list-item.component";

/**
 * Popin de sélection des statuts pour une relance
 */
@Component({
    host: {'data-test-id': 'select-relance-statuts-popin'},
    templateUrl: './select-relance-statuts-popin.component.html'
})
export class SelectRelanceStatutsPopinComponent implements OnInit {
    //Liste des statuts
    listeStatuts: ListView<Statut, StatutRelanceListItemComponent>;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { relance: RelanceDetail, listeStatuts: Statut[] },
        private translateService: TranslateService
    ) {
    }

    ngOnInit(): void {
        //Initialisation de la liste
        this.listeStatuts = new ListView<Statut, StatutRelanceListItemComponent>({
            title: this.translateService.instant('admin.bibliotheque.notifications.relances.selectStatutsPopin.listTitle'),
            component: StatutRelanceListItemComponent,
            isFrontendList: true,
            data: {
                listeResultats: this.data.listeStatuts,
                numPage: 0,
                nbPagesTotal: 1,
                nbObjetsTotal: this.data.listeStatuts.length,
                nbObjetsParPage: this.data.listeStatuts.length,
                nbObjetsDansPage: this.data.listeStatuts.length
            } as Page<Statut>,
            extraOptions: {
                relance: this.data.relance
            },
            listeActions: [{
                icon: 'done_all',
                onPress: () => this.listeStatuts.selectAll(true),
                tooltip: this.translateService.instant('global.actions.toutSelectionner'),
                isVisible: () => !this.listeStatuts?.data.listeResultats.every(s => s.isSelected)
            }, {
                icon: 'remove_done',
                onPress: () => this.listeStatuts.selectAll(false),
                tooltip: this.translateService.instant('global.actions.toutDeselectionner'),
                isVisible: () => this.listeStatuts?.data.listeResultats.every(s => s.isSelected)
            }]
        });
    }
}